const LEADS = {
  LEADS: '/leads',
  DOWNLOAD_LEADS: '/export/download/:key/:fileName'
} as const

export default LEADS
